import { AudioLines, Lightbulb, Thermometer } from "lucide-react";
import { Badge } from "./ui/badge";

export type AgentBadgeVariants = "lighting" | "noise_dose" | "temperature";

function AgentBadge({ variant }: { variant: AgentBadgeVariants }) {
  if (variant === "lighting") {
    return (
      <Badge className="text-white bg-yellow-500 hover:bg-yellow-500/90 flex justify-start gap-1">
        <Lightbulb size={16} /> Illuminacion
      </Badge>
    );
  }

  if (variant === "noise_dose") {
    return (
      <Badge className="text-white bg-blue-300 hover:bg-blue-300/90 flex justify-start gap-1">
        <AudioLines size={16} /> Ruido dosis
      </Badge>
    );
  }

  if (variant === "temperature") {
    return (
      <Badge className="text-white bg-orange-300 hover:bg-orange-300/90 flex justify-start gap-1">
        <Thermometer size={16} /> TGBH
      </Badge>
    );
  }
}

export { AgentBadge };
